import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from '@/locales/en/common.json';
import enHome from '@/locales/en/home.json';
import enAbout from '@/locales/en/about.json';
import enServices from '@/locales/en/services.json';
import enPortfolio from '@/locales/en/portfolio.json';
import enContact from '@/locales/en/contact.json';
import enSeo from '@/locales/en/seo.json';
import enMisc from '@/locales/en/misc.json';
import enTestimonials from '@/locales/en/testimonials.json';
import enFaq from '@/locales/en/faq.json';
import enFooter from '@/locales/en/footer.json';
import enNotfound from '@/locales/en/notfound.json';
import enJotform from '@/locales/en/jotform.json';
import enFillout from '@/locales/en/fillout.json';
import enIndustryRealEstate from '@/locales/en/industry-real-estate.json';
import enIndustryEcommerce from '@/locales/en/industry-ecommerce.json';
import enIndustryRestaurants from '@/locales/en/industry-restaurants.json';
import enIndustryFinancial from '@/locales/en/industry-financial.json';
import enIndustryAgencies from '@/locales/en/industry-agencies.json';
import enIndustryConstruction from '@/locales/en/industry-construction.json';
import en10Reasons from '@/locales/en/10-reasons.json';
import enPricingGuide from '@/locales/en/pricing-guide.json';
import enBuildYourOwn from '@/locales/en/build-your-own.json';
import enCalculatorExamples from '@/locales/en/calculator-examples.json';
import enInteractiveLeadGen from '@/locales/en/interactive-lead-gen.json';
import enCraftsmenCalculator from '@/locales/en/craftsmen-calculator.json';
import enB2BLeadGen from '@/locales/en/b2b-lead-gen.json';
import enInteractiveCalculator from '@/locales/en/interactive-calculator.json';
import enCalculatorMistakes from '@/locales/en/calculator-mistakes.json';

import daCommon from '@/locales/da/common.json';
import daHome from '@/locales/da/home.json';
import daAbout from '@/locales/da/about.json';
import daServices from '@/locales/da/services.json';
import daPortfolio from '@/locales/da/portfolio.json';
import daContact from '@/locales/da/contact.json';
import daSeo from '@/locales/da/seo.json';
import daMisc from '@/locales/da/misc.json';
import daTestimonials from '@/locales/da/testimonials.json';
import daFaq from '@/locales/da/faq.json';
import daFooter from '@/locales/da/footer.json';
import daNotfound from '@/locales/da/notfound.json';
import daJotform from '@/locales/da/jotform.json';
import daFillout from '@/locales/da/fillout.json';
import daIndustryRealEstate from '@/locales/da/industry-real-estate.json';
import daIndustryEcommerce from '@/locales/da/industry-ecommerce.json';
import daIndustryRestaurants from '@/locales/da/industry-restaurants.json';
import daIndustryFinancial from '@/locales/da/industry-financial.json';
import daIndustryAgencies from '@/locales/da/industry-agencies.json';
import daIndustryConstruction from '@/locales/da/industry-construction.json';
import da10Reasons from '@/locales/da/10-reasons.json';
import daPricingGuide from '@/locales/da/pricing-guide.json';
import daBuildYourOwn from '@/locales/da/build-your-own.json';
import daCalculatorExamples from '@/locales/da/calculator-examples.json';
import daInteractiveLeadGen from '@/locales/da/interactive-lead-gen.json';
import daCraftsmenCalculator from '@/locales/da/craftsmen-calculator.json';
import daB2BLeadGen from '@/locales/da/b2b-lead-gen.json';
import daInteractiveCalculator from '@/locales/da/interactive-calculator.json';
import daCalculatorMistakes from '@/locales/da/calculator-mistakes.json';

import skCommon from '@/locales/sk/common.json';
import skHome from '@/locales/sk/home.json';
import skAbout from '@/locales/sk/about.json';
import skServices from '@/locales/sk/services.json';
import skPortfolio from '@/locales/sk/portfolio.json';
import skContact from '@/locales/sk/contact.json';
import skSeo from '@/locales/sk/seo.json';
import skMisc from '@/locales/sk/misc.json';
import skTestimonials from '@/locales/sk/testimonials.json';
import skFaq from '@/locales/sk/faq.json';
import skFooter from '@/locales/sk/footer.json';
import skNotfound from '@/locales/sk/notfound.json';
import skJotform from '@/locales/sk/jotform.json';
import skFillout from '@/locales/sk/fillout.json';
import skIndustryRealEstate from '@/locales/sk/industry-real-estate.json';
import skIndustryEcommerce from '@/locales/sk/industry-ecommerce.json';
import skIndustryRestaurants from '@/locales/sk/industry-restaurants.json';
import skIndustryFinancial from '@/locales/sk/industry-financial.json';
import skIndustryAgencies from '@/locales/sk/industry-agencies.json';
import skIndustryConstruction from '@/locales/sk/industry-construction.json';
import sk10Reasons from '@/locales/sk/10-reasons.json';
import skPricingGuide from '@/locales/sk/pricing-guide.json';
import skBuildYourOwn from '@/locales/sk/build-your-own.json';
import skCalculatorExamples from '@/locales/sk/calculator-examples.json';
import skInteractiveLeadGen from '@/locales/sk/interactive-lead-gen.json';
import skCraftsmenCalculator from '@/locales/sk/craftsmen-calculator.json';
import skB2BLeadGen from '@/locales/sk/b2b-lead-gen.json';
import skInteractiveCalculator from '@/locales/sk/interactive-calculator.json';
import skCalculatorMistakes from '@/locales/sk/calculator-mistakes.json';

import csCommon from '@/locales/cs/common.json';
import csHome from '@/locales/cs/home.json';
import csAbout from '@/locales/cs/about.json';
import csServices from '@/locales/cs/services.json';
import csPortfolio from '@/locales/cs/portfolio.json';
import csContact from '@/locales/cs/contact.json';
import csSeo from '@/locales/cs/seo.json';
import csMisc from '@/locales/cs/misc.json';
import csTestimonials from '@/locales/cs/testimonials.json';
import csFaq from '@/locales/cs/faq.json';
import csFooter from '@/locales/cs/footer.json';
import csNotfound from '@/locales/cs/notfound.json';
import csJotform from '@/locales/cs/jotform.json';
import csFillout from '@/locales/cs/fillout.json';
import csIndustryRealEstate from '@/locales/cs/industry-real-estate.json';
import csIndustryEcommerce from '@/locales/cs/industry-ecommerce.json';
import csIndustryRestaurants from '@/locales/cs/industry-restaurants.json';
import csIndustryFinancial from '@/locales/cs/industry-financial.json';
import csIndustryAgencies from '@/locales/cs/industry-agencies.json';
import csIndustryConstruction from '@/locales/cs/industry-construction.json';
import cs10Reasons from '@/locales/cs/10-reasons.json';
import csPricingGuide from '@/locales/cs/pricing-guide.json';
import csBuildYourOwn from '@/locales/cs/build-your-own.json';
import csCalculatorExamples from '@/locales/cs/calculator-examples.json';
import csInteractiveLeadGen from '@/locales/cs/interactive-lead-gen.json';
import csCraftsmenCalculator from '@/locales/cs/craftsmen-calculator.json';
import csB2BLeadGen from '@/locales/cs/b2b-lead-gen.json';
import csInteractiveCalculator from '@/locales/cs/interactive-calculator.json';
import csCalculatorMistakes from '@/locales/cs/calculator-mistakes.json';

export const resources = {
  en: {
    common: enCommon,
    home: enHome,
    about: enAbout,
    services: enServices,
    portfolio: enPortfolio,
    contact: enContact,
    seo: enSeo,
    misc: enMisc,
    testimonials: enTestimonials,
    faq: enFaq,
    footer: enFooter,
    notfound: enNotfound,
    jotform: enJotform,
    fillout: enFillout,
    'industry-real-estate': enIndustryRealEstate,
    'industry-ecommerce': enIndustryEcommerce,
    'industry-restaurants': enIndustryRestaurants,
    'industry-financial': enIndustryFinancial,
    'industry-agencies': enIndustryAgencies,
    'industry-construction': enIndustryConstruction,
    '10-reasons': en10Reasons,
    'pricing-guide': enPricingGuide,
    'build-your-own': enBuildYourOwn,
    'calculator-examples': enCalculatorExamples,
    'interactive-lead-gen': enInteractiveLeadGen,
    'craftsmen-calculator': enCraftsmenCalculator,
    'b2b-lead-gen': enB2BLeadGen,
    'interactive-calculator': enInteractiveCalculator,
    'calculator-mistakes': enCalculatorMistakes,
  },
  da: {
    common: daCommon,
    home: daHome,
    about: daAbout,
    services: daServices,
    portfolio: daPortfolio,
    contact: daContact,
    seo: daSeo,
    misc: daMisc,
    testimonials: daTestimonials,
    faq: daFaq,
    footer: daFooter,
    notfound: daNotfound,
    jotform: daJotform,
    fillout: daFillout,
    'industry-real-estate': daIndustryRealEstate,
    'industry-ecommerce': daIndustryEcommerce,
    'industry-restaurants': daIndustryRestaurants,
    'industry-financial': daIndustryFinancial,
    'industry-agencies': daIndustryAgencies,
    'industry-construction': daIndustryConstruction,
    '10-reasons': da10Reasons,
    'pricing-guide': daPricingGuide,
    'build-your-own': daBuildYourOwn,
    'calculator-examples': daCalculatorExamples,
    'interactive-lead-gen': daInteractiveLeadGen,
    'craftsmen-calculator': daCraftsmenCalculator,
    'b2b-lead-gen': daB2BLeadGen,
    'interactive-calculator': daInteractiveCalculator,
    'calculator-mistakes': daCalculatorMistakes,
  },
  sk: {
    common: skCommon,
    home: skHome,
    about: skAbout,
    services: skServices,
    portfolio: skPortfolio,
    contact: skContact,
    seo: skSeo,
    misc: skMisc,
    testimonials: skTestimonials,
    faq: skFaq,
    footer: skFooter,
    notfound: skNotfound,
    jotform: skJotform,
    fillout: skFillout,
    'industry-real-estate': skIndustryRealEstate,
    'industry-ecommerce': skIndustryEcommerce,
    'industry-restaurants': skIndustryRestaurants,
    'industry-financial': skIndustryFinancial,
    'industry-agencies': skIndustryAgencies,
    'industry-construction': skIndustryConstruction,
    '10-reasons': sk10Reasons,
    'pricing-guide': skPricingGuide,
    'build-your-own': skBuildYourOwn,
    'calculator-examples': skCalculatorExamples,
    'interactive-lead-gen': skInteractiveLeadGen,
    'craftsmen-calculator': skCraftsmenCalculator,
    'b2b-lead-gen': skB2BLeadGen,
    'interactive-calculator': skInteractiveCalculator,
    'calculator-mistakes': skCalculatorMistakes,
  },
  cs: {
    common: csCommon,
    home: csHome,
    about: csAbout,
    services: csServices,
    portfolio: csPortfolio,
    contact: csContact,
    seo: csSeo,
    misc: csMisc,
    testimonials: csTestimonials,
    faq: csFaq,
    footer: csFooter,
    notfound: csNotfound,
    jotform: csJotform,
    fillout: csFillout,
    'industry-real-estate': csIndustryRealEstate,
    'industry-ecommerce': csIndustryEcommerce,
    'industry-restaurants': csIndustryRestaurants,
    'industry-financial': csIndustryFinancial,
    'industry-agencies': csIndustryAgencies,
    'industry-construction': csIndustryConstruction,
    '10-reasons': cs10Reasons,
    'pricing-guide': csPricingGuide,
    'build-your-own': csBuildYourOwn,
    'calculator-examples': csCalculatorExamples,
    'interactive-lead-gen': csInteractiveLeadGen,
    'craftsmen-calculator': csCraftsmenCalculator,
    'b2b-lead-gen': csB2BLeadGen,
    'interactive-calculator': csInteractiveCalculator,
    'calculator-mistakes': csCalculatorMistakes,
  },
} as const;

export const supportedLanguages = ['en', 'da', 'sk', 'cs'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'about', 'services', 'portfolio', 'contact', 'seo', 'misc', 'testimonials', 'faq', 'footer', 'notfound', 'jotform', 'fillout', 'industry-real-estate', 'industry-ecommerce', 'industry-restaurants', 'industry-financial', 'industry-agencies', 'industry-construction', '10-reasons', 'pricing-guide', 'build-your-own', 'calculator-examples', 'interactive-lead-gen', 'craftsmen-calculator', 'b2b-lead-gen', 'interactive-calculator', 'calculator-mistakes'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
  });

export default i18n;